import { useEffect, useMemo } from 'react';
import { useGlobalStore } from '@core/hooks/useGlobalStore';
import { productsHydratedSelector } from '@core/shopping/model';
import { mergeProductsWithHydrated } from '@core/shopping/utils/mergeProductsWithHydrated';
import { fixIncomingProducts } from '@core/shopping/utils/product';
import { useStore } from '@embed/components/VideoPlayer/Player3/store';
import { hookOnlyVideoProductsSelector } from '@embed/components/VideoPlayer/Player3/store/selectors';
/**
 * Fetches products for the current video and merges them with the hydrated
 * products.
 * @returns A list of products merging the video products and hydrated products.
 */
export function useVideoProducts() {
    const { setVideoProducts } = useStore((state) => state.actions);
    const video = useStore((state) => state.video);
    const originalVideoProducts = useStore((state) => hookOnlyVideoProductsSelector(state, video?.encoded_id));
    const productsHydrated = useGlobalStore(productsHydratedSelector);
    useEffect(() => {
        if (video?.products &&
            video.products.length > 0 &&
            !originalVideoProducts) {
            setVideoProducts({
                videoId: video.encoded_id,
                products: fixIncomingProducts(video?.products),
            });
        }
    }, [
        originalVideoProducts,
        setVideoProducts,
        video?.encoded_id,
        video?.products,
    ]);
    return useMemo(() => mergeProductsWithHydrated(originalVideoProducts ?? [], productsHydrated), [originalVideoProducts, productsHydrated]);
}
